export default __webpack_public_path__ + "static/media/search-icon-green.aa929089.svg";